/**
 * React port of `propertySelectedService.replaceGlobalOrder(orderNumber)`.
 *
 * Source: deleted/public/SPIGlassApp/services/propertySelectedService.js:238-247
 *
 *   function replaceGlobalOrder(orderNumber){
 *       generalDataService.getWorkOrderInfo(orderNumber).then(function (response) {
 *           if (response.data && response.data.id > 0) {
 *               $rootScope.G_WORKORDER = response.data
 *               workflowDataService.getCurrentFinancialWorkflowState($rootScope.G_WORKORDER.orderNumber)
 *                   .then(response => $rootScope.G_WORKORDER_FINANCIAL_WORKFLOW = response.data)
 *           }
 *       })
 *   }
 *
 * Re-hydrates the global work-order + financial-workflow stores so consumers
 * (sidebar status badge, financial workflow gate, etc.) reflect the updated
 * order after operations like Cancel/Uncancel.
 */

import { getWorkOrderInfo } from '@/features/search/searchApi';
import { getCurrentFinancialWorkflowState } from '@/lib/workflowApi';
import { usePropertyStore, type WorkOrder } from '@/store/propertyStore';
import { useAppGlobalsStore, type FinancialWorkflow } from '@/store/appGlobalsStore';

export async function replaceGlobalOrder(orderNumber: string | number): Promise<void> {
  const workOrder = (await getWorkOrderInfo(orderNumber)) as WorkOrder | null | undefined;

  // Match AngularJS guard: `response.data && response.data.id > 0`
  const id = workOrder?.id;
  if (!workOrder || typeof id !== 'number' || id <= 0) return;

  usePropertyStore.getState().setWorkOrder(workOrder);

  const financial = (await getCurrentFinancialWorkflowState(
    String(workOrder.orderNumber)
  )) as unknown as FinancialWorkflow | null;
  useAppGlobalsStore.getState().setFinancialWorkflow(financial ?? null);
}
